	/**
 * NEWSLETTER MODULE
 *
 * Since there is no global Form module yet,
 * form interactions are localized for newsletter for now.
 * Should be updated once global form module is available, if needed.
 * 
 *  http://dev.visitphilly.com/?om-live-preview=kj4arfvlc7n6ihphkato
 *  https://stagevp.visitphilly.com/?om-live-preview=kj4arfvlc7n6ihphkato
 */

VP = window.VP || {};


(function( $ ) {
	/**
	 * PRIVATE VARIABLES
	 */
	var EMAIL_REGEX = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i;
	var POSTAL_REGEX = 	/^[0-9]{5}([- /]?[0-9]{4})?$/i;
	var SELECTOR = {
		newsletter: '.js-newsletter',
		content: '.js-newsletter__content',
		form: 'form',
		email: 'input.js-newsletter__email',
		postal: 'input.js-newsletter__postal',
		source: '.js-newsletter__source',
		convertlabel: '.js-newsletter__convertlabel',
		submit: '[type="submit"]',
		elabel: '.vp-newsletter__error',
		faker: '[name="email_faker"]'
	};
	var CLASSNAME = {
		formError: 'vp-newsletter__form--error',
		formSuccess: 'vp-newsletter__form--success',
		formBusy: 'vp-newsletter__form--busy',
		animatable: 'animatable',
		disclosed: 'vp-newsletter--disclosed',
	};
	var DESKTOP_MIN_WIDTH = 999;
	var $window = $(window);
	var currentScroll = window.pageYOffset;

	/**
	 * NEWLETTER CLASS
	 */
    
    
	var Newsletter = function ($element) {
		var _this = this;

        //console.log("[newsletter] " + _this);


		// Just ensure we have a jQuery object here
		this.$element = $($element);
		this.element = this.$element[0];

		// OptinMonster class
		this.$optin = this.element.className || '';

		this.$wrapper = this.$element.parent();
		this.$content = this.$element.find(SELECTOR.content);
		this.$form = this.$element.find(SELECTOR.form);
		this.$email = this.$form.find(SELECTOR.email);
		this.$postal = this.$form.find(SELECTOR.postal);
		this.$source = this.$form.find(SELECTOR.source);
		this.$convertlabel = this.$form.find(SELECTOR.convertlabel);
		this.$submit = this.$form.find(SELECTOR.submit);
		this.$elabel = this.$form.find(SELECTOR.elabel);
		this.$faker = this.$form.find(SELECTOR.faker);

        this.$checkGuide = this.$form.find('input[name="check_guide"]');
        this.$checkWeek = this.$form.find('input[name="check_week"]')


		this.defaultError = "We apologize, something went wrong on our end. Please try again later.";

		this.defaultLabel = this.$form.data('labelDefault');
		this.successLabel = this.$form.data('labelSuccess');
		this.succesBtnTxt = this.$form.data('labelBtnSuccess');
		this.isBusy = false;

		this.action = this.$form.attr('action');
		this.method = this.$form.attr('method');

        this.ismodule = this.$form.parents(".vp-module.vp-newsletter-wrapper").length > 0;
                  
 
        // console.log(
        //     this.$wrapper,
        //     this.$content,
        //     this.$form,
        //     this.$email,
        //     this.$postal,
        //     this.$source,
        //     this.$convertlabel,
        //     this.$submit,
        //     this.$elabel,
        //     this.$faker,
        //     this.$checkGuide,
        //     this.$checkWeek
        // );
		this.bindForm();

		setTimeout(function () {
			_this.bindScroll();
		}, 1000);

		this.$element.data('newsletter', this);
	};

	Newsletter.prototype = $.extend({}, Newsletter.prototype, {
		bindForm: function () {
			var _this = this;


			this.$form.on('submit', function ( e ) {
				e.preventDefault();

				if ( this.isBusy ) {
					return false;
				}

				_this.$form.removeClass(CLASSNAME.formError);

                _this.submit(); // skip js validation for testing server side validation
                
			});

			this.$email
			.bind('focus', function (e) {
				_this.showDefaultState();
                _this.setTabOrder();
			})
			.bind('keyup change', function () {
				_this.showDefaultState();
                _this.setTabOrder();
			});

		
            this.$checkGuide.bind('click change', function () {
				_this.showDefaultState();
			});
            this.$checkWeek.bind('click change', function () {
				_this.showDefaultState();
			});
		},

        // note: the tab order is being reset by AudioEye   
        setTabOrder: function() {
            let ti = 1;
            var _this = this;
            if (!this.ismodule) { // if popup, don't set tabindex
               return;
            }
            this.$email    .attr('tabindex', ti++);
            this.$postal   .attr('tabindex', ti++);
            this.$checkGuide.attr('tabindex', ti++);
            this.$checkWeek.attr('tabindex', ti++);
            this.$submit   .attr('tabindex', ti++);
        },

		bindScroll: function () {
			var _this = this;
			// Do not resort if OptinMonster
			if (this.$optin.indexOf('vp-om-contain') !== -1) { this.isVisible = true; }
			

			$window.on('scroll', function () {
				_this.onScroll();
			});

			_this.onScroll();
		},

		onScroll: function () {
            var windowHeight = $window.outerHeight();
			var elementTop = this.$element.offset().top;

			this.targetScroll = elementTop - (windowHeight * 0.75) ;
			currentScroll = window.pageYOffset;
			if ( $window.outerWidth() < DESKTOP_MIN_WIDTH || this.isVisible || currentScroll < this.targetScroll ) { return; }
			this.disclose();
		},

		disclose: function () {
			var _this = this;
			// Get widths
			var currentWidth = this.$element.outerWidth();

			// Set widths
			this.$content.width(currentWidth);
			this.$element.width(0);

			setTimeout(function () {
				_this.$wrapper.addClass([CLASSNAME.disclosed, CLASSNAME.animatable].join(' '));
			}, 1);

			// Ensure function to be called on a later stack
			setTimeout(function () {
				_this.$element.one('transitionend', function (e) {
					if ( e.target === _this.$element[0] ) {
						_this.$content.width('');
						_this.$element.width('');
						_this.$wrapper.removeClass( CLASSNAME.animatable );
					}
				});
				_this.$content.width('');
				_this.$element.width('');
			}, 2);

			this.isVisible = true;
		},


	
		submit: function () {

			//console.log("[newsletter] submit");
			var _this = this;
			var email = this.$email.val();
			var postal = this.$postal.val();
			var faker = this.$faker.val();

			var source = this.$source.val();
			var convertlabel = this.$convertlabel.val();
			//var checkconfirm = this.$checkconfirm.val();

              // new vars
            var guideChecked = this.$checkGuide.is(':checked') ? 1 : 0;
            var weekChecked  = this.$checkWeek.is(':checked')  ? 1 : 0;

			this.showBusy();


            var browser = VP.helpers.isMobile()? 'mobile':'desktop';
            var formtype = this.$form.parents(".Campaign__canvas").length?'optinmonster':'pagemodule';


			var postvars = {
                email:       email,
                postal:      postal,
                faker:       faker,
                source:      source,
                check_guide:  guideChecked,
                check_week:   weekChecked,
                browser:    browser,
                formtype:   formtype
            };

            VP.request.post(
                this.action,
                postvars,

                // ——— SUCCESS (2xx responses) ———
                function(response, status, xhr) {
                    let data;

                    // try to parse JSON
                    try {
                    data = (typeof response === 'string')
                        ? JSON.parse(response)
                        : response;
                    } catch (e) {
                        console.error('Invalid JSON response', response);
                        _this.$elabel.text(_this.defaultError);                        
                        return _this.showError();
                    }

                    // handle validation errors
                    if (data.status === 'validation') {
                        _this.$elabel.text(data.message);                        
                        if (data.focus) {
                            const $target = _this.$wrapper.find(data.focus);
                            if ($target.length) {
                                $target.focus();
                            }
                        }
                        _this.showError();
                        return;
                    }

                    // otherwise it’s a “success”
                    _this.showSuccess();

                    if (typeof dataLayer !== 'undefined') {
                        dataLayer.push({ event: 'newsletterConvert' });
                        if (source.indexOf('optinmonster') > -1) {
                            dataLayer.push({ event: 'newsletterConvertOM' });
                        }
                    }
                },

                // ——— ERROR (4xx/5xx responses) ———
                function(errorText, xhr) {
                    console.log('[newsletter] Post Error:', errorText, xhr);
                    let msg = _this.defaultError;

                    // try to pull the JSON message out of xhr.responseText
                    try {
                    const err = JSON.parse(xhr.responseText);
                        if (err && err.message) msg = err.message;
                    } catch (e) {
                        // fall back to defaultError
                    }

                    _this.$elabel.text(msg);
                    _this.showError();
                }
            );

		},

		showDefaultState: function () {
			//$('.vp-om-title').removeClass('vp-om-title_ty').text('Wait!');
			$('.vp-om-subtitle').show();
			this.$form.removeClass([CLASSNAME.formSuccess, CLASSNAME.formBusy, CLASSNAME.formError].join(' '));
			this.$form.show();
		},

		showError: function () {
            // adds vp-newsletter__form--error to form to enable message
			this.$form
				.removeClass([CLASSNAME.formSuccess, CLASSNAME.formBusy].join(' '))
				.addClass(CLASSNAME.formError);
			this.isBusy = false;
		},

		showBusy: function () {
			this.$form
				.removeClass([CLASSNAME.formSuccess, CLASSNAME.formError].join(' '))
				.addClass(CLASSNAME.formBusy);
			this.isBusy = true;
		},

		showSuccess: function () {            
			this.$form
				.removeClass([CLASSNAME.formBusy, CLASSNAME.formError].join(' '))
				.addClass(CLASSNAME.formSuccess);

            // IF OM POPUP, HAVE DONE BUTTON TRIGGER CLOSE
            var $omCanvas = this.$form.parents(".Campaign__canvas");
            if ($omCanvas.length) { 

            // 1) show your thank-you text
            $omCanvas.find(".vp-newsletter__success")
                    .text("Thank you for subscribing.");
            $omCanvas.find(".vp-newsletter__details")
                    .css("opacity", 0);

            // 2) fire the OM conversion  
            //    grab the surrounding .Campaign element…
            var $campaign = $omCanvas.closest(".Campaign");
            //    …read its `id` (“om-kj4arfvlc7n6ihphkato”)
            var idAttr = $campaign.prop("id");
            if (idAttr) {
                //    remove the dash so it matches the global: “omkj4arfvlc7n6ihphkato”
                var omGlobalName = idAttr.replace(/^om-/, "om");
                var omInst = window[omGlobalName];
                if (omInst && omInst.Listeners && typeof omInst.Listeners.convert === "function") {
                    console.log("[conversion trigger]",omInst);
                    omInst.Listeners.convert();
                }
            }

            // 3) close the popup after 2s
            var $popclose = $omCanvas.find("button").first();
            setTimeout(function() {
                    if ($popclose.length) {			
                    $popclose.trigger("click");
                    }
                }, 2000);
            }


            var $moduleform = this.$form.parents(".vp-module.vp-newsletter-wrapper");
            if ($moduleform.length) { 
                $moduleform.find(".vp-newsletter__success").text("Thank you for subscribing.");
                $moduleform.find(".vp-newsletter__form").css("opacity",0);                
            }

            Cookies.set('newslettersuccess', '1', { expires: 3650, path: '/' }); // 10 years

			this.isBusy = false;
		},

	});

	/**
	 * NEWSLETTER MODULE ATTACHED TO APP
	 */
	VP.newsletter = {
        
		$elements: $(SELECTOR.newsletter),
		instances: [],

		init: function () {
            
			var _this = this;

			// Push OptInMonster sign-up elements to array, if they fire // Old methodology
			$(document).on('OptinMonsterOnShow', function(event, data, object) {               
				$('.js-newsletter.vp-om-contain').each(function () {
					_this.instances.push(new Newsletter(this));
				});
			});
            // new methodology            
            document.addEventListener('om.Campaign.afterShow', function(event) {               
                // Add your own logic here to check if a video is playing
                 console.log("INIT!",$('.vp-newsletter__om.js-newsletter').length);
                $('.vp-newsletter__om.js-newsletter').each(function () {
                    _this.instances.push(new Newsletter(this));
                });
            } );
            
			// Push regular sign-up elements to array
			_this.$elements.each(function () {
				_this.instances.push(new Newsletter(this));
			});
		},
	};

})(jQuery);
